import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import Form from '../../components/forms/InitiativeFormAdding';
import { saveInitiative, acceptInitiative, replyInitiative, withRedirect } from '../../CroActions';
import { isLegitimate, isInternal } from '../../CroUtils';
import { breadcrumbs } from '../../../../actions/appActions';
import { convert, addressToForm } from '../../converts';

const postProcess = data => convert(data, {
  person: {
    address: addressToForm,
    deliveryAddress: addressToForm,
  },
});
const selector = formValueSelector('initiativeForm');

const mapStateToProps = (state, { params, auth }) => ({
  breadcrumbsItems: [{ label: 'Podněty k prošetření' }, { label: 'Editace podnětu' }],
  attachments: selector(state, 'attachments') || [],
  resultAttachments: selector(state, 'resultAttachments') || [],
  state: selector(state, 'state'),
  legalPerson: selector(state, 'legalPerson') || '',
  url: `${auth.startUrl}/api/podnety/${params.id}`,
  disabled: isLegitimate(auth),
  postProcess,
  rejectText: selector(state, 'rejectText'),
  text: selector(state, 'text'),
});

const mapDispatchToProps = (dispatch, { params, auth }) => ({
  ...bindActionCreators({ breadcrumbs }, dispatch),
  onSubmit: (...args) => dispatch(withRedirect(saveInitiative, `${auth.startUrl}/podnety`)(...args)),
  accept: data => dispatch(withRedirect(acceptInitiative, `${auth.startUrl}/podnety`)(data)),
  reply: data => dispatch(withRedirect(replyInitiative, `${auth.startUrl}/podnety`)(data)),
  reject: () => dispatch(push(`${auth.startUrl}/podnety/${params.id}/zamitnout`)),
  send: () => dispatch(push(`${auth.startUrl}/podnety/${params.id}/postoupit`)),
  onShowHistory: (params.id && isInternal(auth))
    ? () => dispatch(push(`${auth.startUrl}/podnety/${params.id}/historie`))
    : null,
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(Form);
